import useWebSocket from "react-use-websocket";
import React from "react";
import { TxType } from "@/types/transaction";

export interface UploadStatusMessage {
  progress: number;
  tx_id: string;
  tx_type: TxType;
  type: "transaction" | "document" | "snapshot";
  fse_ids: string[];
}

export const useUploadStatus = (onProgress: (event: UploadStatusMessage) => void) => {
  const { lastJsonMessage } = useWebSocket<UploadStatusMessage>("/pf-document/status", {
    share: true,
    skipAssert: true,
    shouldReconnect: event => event?.code !== 1000,
  });

  React.useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }

    onProgress(lastJsonMessage);
  }, [lastJsonMessage, onProgress]);
};
